import React, { FC } from "react";
import { v4 as uuidv4 } from "uuid";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles, Theme } from "@material-ui/core/styles";

import { commonStyles } from "theme/common";
import { Title } from "shared/components";

interface ListProps {
  title: React.ReactNode;
  items: React.ReactNode[];
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    list: {
      padding: 0,
      listStyleType: "none",
    },
    listItem: {
      display: "flex",
      alignItems: "center",
      paddingLeft: theme.spacing(2),
      "&:before": {
        content: ' "-" ',
        display: "flex",
        alignItems: "center",
        marginLeft: -theme.spacing(2),
        marginRight: theme.spacing(1),
        height: theme.spacing(2),
      },
    },
    ...commonStyles(theme),
  };
});

const List: FC<ListProps> = ({ title, items }) => {
  const classes = useStyles();

  return (
    <>
      <Title title={title} />
      <Box className={classes.ml3}>
        <ul className={classes.list}>
          {items &&
            items.map((item) => (
              <li key={uuidv4()} className={classes.listItem}>
                <Typography variant="body1">{item}</Typography>
              </li>
            ))}
        </ul>
      </Box>
    </>
  );
};

export default List;
